export default "__VITE_ASSET__e89b1a9b__"